var map = {
	"./david_lee.png": 628,
	"./default_avatar.png": 2120,
	"./emily_davis.png": 6663,
	"./james_anderson.png": 4828,
	"./jane_smith.png": 6449,
	"./john_doe.png": 1611,
	"./mike_johnson.png": 3491,
	"./olivia_brown.png": 246,
	"./robert_wilson.png": 4110,
	"./sophia_martinez.png": 8598
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 449;